/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { application_id } from '../models/application_id';
import type { application_right_template_id } from '../models/application_right_template_id';
import type { application_type_binary_platform } from '../models/application_type_binary_platform';
import type { application_type_id } from '../models/application_type_id';
import type { ApplicationAndCounterForList } from '../models/ApplicationAndCounterForList';
import type { ApplicationConfigParams } from '../models/ApplicationConfigParams';
import type { applicationdevice_id } from '../models/applicationdevice_id';
import type { ApplicationDeviceForList } from '../models/ApplicationDeviceForList';
import type { ApplicationDeviceListParams } from '../models/ApplicationDeviceListParams';
import type { ApplicationForNew } from '../models/ApplicationForNew';
import type { ApplicationForNewParams } from '../models/ApplicationForNewParams';
import type { ApplicationForUpdateParams } from '../models/ApplicationForUpdateParams';
import type { ApplicationListParams } from '../models/ApplicationListParams';
import type { ApplicationRight } from '../models/ApplicationRight';
import type { ApplicationRightsUpdateParams } from '../models/ApplicationRightsUpdateParams';
import type { ApplicationRightTemplate } from '../models/ApplicationRightTemplate';
import type { ApplicationRightTemplateSummary } from '../models/ApplicationRightTemplateSummary';
import type { ApplicationRightTemplateWriteParams } from '../models/ApplicationRightTemplateWriteParams';
import type { ApplicationType } from '../models/ApplicationType';
import type { ApplicationTypeBinary } from '../models/ApplicationTypeBinary';
import type { ApplicationTypeWriteParams } from '../models/ApplicationTypeWriteParams';
import type { DetailledApplicationWithDevices } from '../models/DetailledApplicationWithDevices';
import type { PublicDownloadApplication } from '../models/PublicDownloadApplication';
import type { PutApplicationsSourceLoginReq } from '../models/PutApplicationsSourceLoginReq';
import type { PutApplicationsSourceLoginResp } from '../models/PutApplicationsSourceLoginResp';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ApplicationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a new Application
     * Creates a new Application. (Access: admin)
     * @returns any Unexpected error
     * @returns ApplicationForNew Applications created
     * @throws ApiError
     */
    public createApplication({
        formData,
    }: {
        /**
         * Application's information
         */
        formData: {
            /**
             * JSON data for application
             */
            data: ApplicationForNewParams;
            files?: (Blob | Array<Blob>);
        },
    }): CancelablePromise<{
        code: number;
        message: string;
    } | ApplicationForNew> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/applications',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Conflict`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get a list of Applications
     * Get a list of Applications. (Access: admin)
     * @returns ApplicationAndCounterForList Applications list
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getApplications({
        requestBody,
    }: {
        /**
         * Application's information
         */
        requestBody: ApplicationListParams,
    }): CancelablePromise<Array<ApplicationAndCounterForList> | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/applications/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a list of application devices
     * Devices on which users logged into the applications of the visible contracts, most recently connected first. (Access: applications.list)
     * @returns any Application devices list
     * @throws ApiError
     */
    public getApplicationDevices({
        requestBody,
    }: {
        requestBody: ApplicationDeviceListParams,
    }): CancelablePromise<{
        devices: Array<ApplicationDeviceForList>;
        total_devices: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/applications/devices/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Get an Application
     * Returns a Application based on a single ID (Access: admin, customer)
     * @returns DetailledApplicationWithDevices Application's information
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getApplicationById({
        id,
    }: {
        /**
         * ID of the Application to fetch
         */
        id: application_id,
    }): CancelablePromise<DetailledApplicationWithDevices | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/applications/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update Application
     * Update an Application's information and send its configuration file in the same request. (Access: admin)
     * @returns any Application updated and/or configuration file saved.
     * @throws ApiError
     */
    public updateApplication({
        id,
        formData,
    }: {
        /**
         * ID of the Application
         */
        id: string,
        /**
         * Application's information and configuration file
         */
        formData: {
            /**
             * JSON data for application update
             */
            data: ApplicationForUpdateParams;
            files?: (Blob | Array<Blob>);
        },
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/applications/{id}',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Delete a application
     * Deletes a single Application based on the ID supplied. (Access: admin)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteApplicationById({
        id,
    }: {
        /**
         * ID of the Application to delete
         */
        id: application_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/applications/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get application rights
     * Returns the actual rights attached to one application (Access: admin)
     * @returns ApplicationRight Application rights
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getApplicationRights({
        id,
    }: {
        /**
         * ID of the application
         */
        id: application_id,
    }): CancelablePromise<Array<ApplicationRight> | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/applications/{id}/rights',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update application rights
     * Replaces the actual rights attached to one application (Access: admin)
     * @returns ApplicationRight Updated application rights
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateApplicationRights({
        id,
        requestBody,
    }: {
        /**
         * ID of the application
         */
        id: application_id,
        requestBody: ApplicationRightsUpdateParams,
    }): CancelablePromise<Array<ApplicationRight> | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/applications/{id}/rights',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Download a specific file of an Application (for debugging purpose)
     * Get a configuration file of an Application. (Access: customer)
     * @returns binary config file
     * @returns any Unexpected error
     * @throws ApiError
     */
    public downloadApplicationFile({
        id,
        fileId,
        jwt,
    }: {
        /**
         * ID of the Application to fetch
         */
        id: application_id,
        /**
         * Id of the file to fetch
         */
        fileId: string,
        /**
         * jwt token
         */
        jwt?: string,
    }): CancelablePromise<Blob | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/applications/download/{id}/{fileId}',
            path: {
                'id': id,
                'fileId': fileId,
            },
            query: {
                'jwt': jwt,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a configuration file of an Application
     * Get a configuration file of an Application. (Access: customer)
     * @returns binary Configuration file
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getApplicationConfig({
        requestBody,
    }: {
        /**
         * Application's information
         */
        requestBody: ApplicationConfigParams,
    }): CancelablePromise<Blob | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/applications/config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Free an applicationdevice from a user device
     * Free an applicationdevice from a user device. (Access: admin)
     * @returns any Application now available
     * @throws ApiError
     */
    public freeApplicationFromDevice({
        id,
    }: {
        /**
         * ID of the ApplicationDevice record
         */
        id: applicationdevice_id,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/applications/freedevice/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get the list of the application types
     * Returns the list of the application types (Access: users with application_types.read)
     * @returns ApplicationType Application types
     * @throws ApiError
     */
    public getApplicationsTypes(): CancelablePromise<Array<ApplicationType>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/applications/types',
        });
    }
    /**
     * Create an application type
     * Creates a new application type (Access: users with application_types.manage)
     * @returns any Unexpected error
     * @returns ApplicationType Application type created
     * @throws ApiError
     */
    public createApplicationType({
        requestBody,
    }: {
        requestBody: ApplicationTypeWriteParams,
    }): CancelablePromise<{
        code: number;
        message: string;
    } | ApplicationType> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/applications/types',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Get an application type
     * Returns one application type (Access: users with application_types.read)
     * @returns ApplicationType Application type
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getApplicationType({
        id,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
    }): CancelablePromise<ApplicationType | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/applications/types/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update an application type
     * Updates one application type (Access: users with application_types.manage)
     * @returns ApplicationType Application type updated
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateApplicationType({
        id,
        requestBody,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
        requestBody: ApplicationTypeWriteParams,
    }): CancelablePromise<ApplicationType | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/applications/types/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Delete an application type
     * Deletes one application type when it is unused (Access: users with application_types.manage)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteApplicationType({
        id,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/applications/types/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Upload the downloadable binary of an application type for one platform
     * Stores the binary published on the Nomade Cars downloads page for this application type and platform. It replaces the platform's previous binary (Access: users with application_types.manage)
     * @returns any Unexpected error
     * @returns ApplicationTypeBinary Binary stored
     * @throws ApiError
     */
    public uploadApplicationTypeBinary({
        id,
        platform,
        formData,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
        /**
         * Target platform
         */
        platform: application_type_binary_platform,
        formData: {
            /**
             * Binary file to publish
             */
            file: Blob;
        },
    }): CancelablePromise<{
        code: number;
        message: string;
    } | ApplicationTypeBinary> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/applications/types/{id}/binaries/{platform}',
            path: {
                'id': id,
                'platform': platform,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Delete the downloadable binary of an application type for one platform
     * Removes the platform's binary from the downloads storage (Access: users with application_types.manage)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteApplicationTypeBinary({
        id,
        platform,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
        /**
         * Target platform
         */
        platform: application_type_binary_platform,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/applications/types/{id}/binaries/{platform}',
            path: {
                'id': id,
                'platform': platform,
            },
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * List the applications published on the Nomade Cars downloads page
     * Returns the application types marked as visible on the downloads page that have at least one binary (Access: all)
     * @returns PublicDownloadApplication Published applications
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getPublicDownloads(): CancelablePromise<Array<PublicDownloadApplication> | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/downloads',
        });
    }
    /**
     * List application type right templates
     * Returns the named right templates for one application type (Access: users with application_type_right_templates.read or application_type_right_templates.manage)
     * @returns ApplicationRightTemplateSummary Application right templates
     * @returns any Unexpected error
     * @throws ApiError
     */
    public listApplicationRightTemplates({
        id,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
    }): CancelablePromise<Array<ApplicationRightTemplateSummary> | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/applications/types/{id}/right-templates',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Create application right template
     * Creates a named application right template for one application type (Access: users with application_type_right_templates.manage)
     * @returns any Unexpected error
     * @returns ApplicationRightTemplate Created application right template
     * @throws ApiError
     */
    public createApplicationRightTemplate({
        id,
        requestBody,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
        requestBody: ApplicationRightTemplateWriteParams,
    }): CancelablePromise<{
        code: number;
        message: string;
    } | ApplicationRightTemplate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/applications/types/{id}/right-templates',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Get application right template
     * Returns one named application right template for one application type (Access: users with application_type_right_templates.read or application_type_right_templates.manage)
     * @returns ApplicationRightTemplate Application right template
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getApplicationRightTemplate({
        id,
        templateId,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
        /**
         * ID of the application right template
         */
        templateId: application_right_template_id,
    }): CancelablePromise<ApplicationRightTemplate | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/applications/types/{id}/right-templates/{templateId}',
            path: {
                'id': id,
                'templateId': templateId,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update application right template
     * Updates one named application right template for one application type (Access: users with application_type_right_templates.manage)
     * @returns ApplicationRightTemplate Updated application right template
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateApplicationRightTemplate({
        id,
        templateId,
        requestBody,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
        /**
         * ID of the application right template
         */
        templateId: application_right_template_id,
        requestBody: ApplicationRightTemplateWriteParams,
    }): CancelablePromise<ApplicationRightTemplate | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/applications/types/{id}/right-templates/{templateId}',
            path: {
                'id': id,
                'templateId': templateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Delete application right template
     * Deletes one named application right template for one application type (Access: users with application_type_right_templates.manage)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteApplicationRightTemplate({
        id,
        templateId,
    }: {
        /**
         * ID of the application type
         */
        id: application_type_id,
        /**
         * ID of the application right template
         */
        templateId: application_right_template_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/applications/types/{id}/right-templates/{templateId}',
            path: {
                'id': id,
                'templateId': templateId,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Get configuration files
     * Returns a zip of configuration files (Access: logged admin)
     * @returns binary Zip file of config
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getApplicationFiles({
        id,
        jwt,
    }: {
        /**
         * Id of the application
         */
        id: application_id,
        /**
         * jwt token
         */
        jwt?: string,
    }): CancelablePromise<Blob | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/applications/download/{id}',
            path: {
                'id': id,
            },
            query: {
                'jwt': jwt,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Used by a source application to log into a service
     * Used by a source application to log into a service (Access: admin, user_customer, user_reseller)
     * @returns PutApplicationsSourceLoginResp Application is logged
     * @returns any Unexpected error
     * @throws ApiError
     */
    public applicationsSourceLogin({
        requestBody,
    }: {
        requestBody: PutApplicationsSourceLoginReq,
    }): CancelablePromise<PutApplicationsSourceLoginResp | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/applications/source/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
